import { styled, Typography } from '@mui/material';

export const FormContainer = styled('div')`
  width: 100%;
  max-width: 742px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid #ddd;
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 32px 24px;
  position: relative;

  @media (max-width: 1023px) {
    width: 100%;
    padding: 16px 8px;
    margin-bottom: 110px;
    &.editMode {
      margin-bottom: 0px;
    }
  }
`;

export const FormFooter = styled('div')`
  display: flex;
`;
export const HeaderW = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
`;

export const FormTitle = styled(Typography)`
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;

  @media (max-width: 1023px) {
    margin-bottom: 0px;
  }
`;

export const TitleW = styled('div')`
  width: 65%;

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const SelectW = styled('div')`
  width: 30%;

  @media (max-width: 1023px) {
    width: 100%;
    margin-top: 16px;
  }
`;

export const NumberInputW = styled('div')`
  width: 49.3%;

  @media (max-width: 1023px) {
    width: 100%;
    margin-top: 16px;
  }
`;

export const SubmitBtnW = styled('div')`
  margin-left: auto;

  @media (max-width: 1023px) {
    margin-top: 32px;
  }
`;
